import * as craft from '@candulabs/craft';
import invariant from 'invariant';

import useEditorNode from './useEditorNode';

/**
 * Hooks used to easily access the node context.
 *
 * A node context is applied in Craft just above the place where a node is rendered,
 * so it's only avaliable in the immediate context of the editor or in the `related`.
 * However, it is not avaliable in the `Toolbox` or anywhere outside of a node being render from `resolver`.
 *
 * Splitting it in two hooks allows us to compose functions better
 */
// TODO: this should just a wrapper for useNode
const useNodeContext = () => {
  const { id } = craft.useNode() || {};
  const { connectors } = useEditorNode(id);

  invariant(id, '(useNodeContext) No node context exists');

  return {
    id,
    connectors,
  };
};

export default useNodeContext;
